// extracted by mini-css-extract-plugin
export default {"container":"register_container__WkJ21","header":"register_header__54Mrj","info":"register_info__nPEM5","button":"register_button__z4rry"};